export default "__VITE_ASSET__BP8BoxkQ__"